"use client";
import { ReactNode } from "react";

const RestaurantLayout = ({ children }: { children: ReactNode }) => {
  return (
    <section className="bg-[#F7F4F8] sm:bg-transparent">{children}</section>
  );
};

export default RestaurantLayout;
